// @ts-check
import { store } from "./FeatureFlags";

/**
 * @param {import("./FeatureFlags").FeatureFlagStore} store
 */
export const featureFlagService = (store) => ({
   /**
    * Check whether a flag is currently enabled or not
    * @param {string} flagId The ID of the feature flag
    * @returns {boolean}
    * @example
    * featureFlags.isEnabled("cisco.dna.core.theme/enabled");
    */
   isEnabled(flagId) {
      return store.get(flagId)?.enabled() ?? false;
   },
});

export default featureFlagService(store);
